import { OptionalCampaignDto } from "@apiModels/BookingSteps/OptionalCampaignDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import React, { FC } from "react";
import { FourthStepInfoContainer } from "../FormElements";

interface OptionalCampaignProps {
  optionalCampaign?: OptionalCampaignDto;
  service: ServiceDto;
  center: LocationDto;
}

export const OptionalCampaign: FC<OptionalCampaignProps> = ({
  optionalCampaign,
  service,
  center,
}) => {
  const shouldShow =
    !!optionalCampaign &&
    !!optionalCampaign.body &&
    !service.disableOptionalCampaignHighlight &&
    !optionalCampaign.disabledCenters.some((c) => c == center.id);

  if (!shouldShow) {
    return null;
  }

  return (
    <FourthStepInfoContainer
      backgroundColor={optionalCampaign?.backgroundColor}
    >
      {!!optionalCampaign.heading && <h3>{optionalCampaign.heading}</h3>}
      <div dangerouslySetInnerHTML={{ __html: optionalCampaign.body }} />
      <p className="mb-1">
        <a href={optionalCampaign.link?.url}>
          <span className="d-flex justify-content-start">
            <span className="fw-bold">{optionalCampaign.link?.title}</span>
            <span className="square-cta__btn-arrow__small mx-1" />
          </span>
        </a>
      </p>
    </FourthStepInfoContainer>
  );
};
